var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('a',{staticClass:"skip-link",attrs:{"href":"#app"}},[_vm._v("Skip to main")]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }